import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { userStorage, StoredUser } from '../services/userStorage';
import { UserRole } from '../types';

// Hook optimizado para cargar información del perfil solo cuando se necesite
export const useAuthProfile = () => {
  const { isAuthenticated } = useAuth();
  const [storedUser, setStoredUser] = useState<StoredUser | null>(null);
  const [userRole, setUserRole] = useState<UserRole | null>(null);
  const [isProfileLoading, setIsProfileLoading] = useState(false);
  const [hasLoadedProfile, setHasLoadedProfile] = useState(false);

  // Cargar perfil solo cuando se solicite explícitamente
  const loadProfile = async () => {
    if (!isAuthenticated || hasLoadedProfile) return;
    
    setIsProfileLoading(true);
    try {
      const userData = await userStorage.getUser();
      setStoredUser(userData);
      
      if (userData) {
        const role = userStorage.getUserRole();
        setUserRole(role);
      }
      
      setHasLoadedProfile(true);
    } catch (error) {
      console.error('Error cargando perfil:', error);
    } finally {
      setIsProfileLoading(false);
    }
  };

  // Cargar perfil automáticamente si no se ha cargado
  useEffect(() => {
    if (isAuthenticated && !hasLoadedProfile) {
      loadProfile();
    }
  }, [isAuthenticated, hasLoadedProfile]);

  return {
    storedUser,
    userRole,
    isProfileLoading,
    hasLoadedProfile,
    loadProfile, // Función para forzar recarga
    // Funciones de utilidad
    isOwner: () => userRole?.id === 'owner',
    isManager: () => userRole?.id === 'manager',
    isWaiter: () => userRole?.id === 'waiter',
    isKitchen: () => userRole?.id === 'kitchen',
    isManagerOrKitchen: () => userRole?.id === 'manager' || userRole?.id === 'kitchen',
  };
};
